"use client";
import { FC, CSSProperties, MouseEventHandler, ButtonHTMLAttributes } from "react";
import { RotatingLines } from "react-loader-spinner";
import cn from "classnames";
import { useRouter } from "next/navigation";
import { FormElementProps } from ".";
import Styles from "./forms.module.scss";

interface ButtonProps extends FormElementProps, ButtonHTMLAttributes<HTMLButtonElement>  {
  tip?: string;
  circle?: number | boolean;
  loading?: boolean;
  value?: string;
  disabled?: boolean;
  href?: string;
  action?: (e:MouseEventHandler<HTMLButtonElement>) => void;
}

export const Button: FC<ButtonProps> = ({
  children,
  tip,
  klass,
  circle = false,
  variant = "standard",
  value,
  size = "md",
  href,
  onClick = () => {},
  customClass = false,
  stretch = false,
  loading = false,
  disabled = false,
  ...props
}) => {
  let rounded = "";
  const style: CSSProperties = {};
  const router = useRouter();

  if (circle) {
    rounded = "rounded-full";
    if (typeof circle === "number") {
      style.width = `${circle}px`;
      style.height = `${circle}px`;
    }
  }

  const classes = cn(
    customClass || Styles.button,
    klass,
    rounded,
    variant,
    size,
    stretch && "w-full",
  );

  const _oncClick: MouseEventHandler<HTMLButtonElement> = async (e) => {
    if (href) {
      await router.push(href);
    } else {
      onClick(e);
    }
  };

  return (
    <button
      className={cn(classes, klass)}
      style={style}
      onClick ={_oncClick}
      disabled={disabled || loading}
      {...props as ButtonHTMLAttributes<HTMLButtonElement>}
    >
      {children || value}
      {tip && <div className="tip">{tip}</div>}
      {loading && (
        <div className={Styles.spinner}>
          <RotatingLines
            width="24"
            strokeColor="white"
            strokeWidth="3"
            animationDuration="1s"
          />
        </div>
      )}
    </button>
  );
};

export default Button;
